import { objEmpty, isFunction } from '../util/helpers';
const GLOBAL = 'GLOBAL';
const queue = {};

const isQueued = function (eventName) {
  let uniqueId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GLOBAL;
  return queue.hasOwnProperty(eventName) && queue[eventName].hasOwnProperty(uniqueId);
};

const queueLength = function (eventName) {
  let uniqueId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GLOBAL;

  if (!isQueued(eventName, uniqueId)) {
    return 0;
  }

  return queue[eventName][uniqueId].length;
};

const register = function (eventName, callback) {
  let uniqueId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : GLOBAL;

  if (!queue.hasOwnProperty(eventName)) {
    queue[eventName] = {};
  }

  if (!queue[eventName].hasOwnProperty(uniqueId)) {
    queue[eventName][uniqueId] = [];
  }

  queue[eventName][uniqueId].push(callback);
};

const registerOnce = function (eventName, callback) {
  let uniqueId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : GLOBAL;

  const cb = function (data) {
    deRegister(eventName, cb, uniqueId);
    callback(data);
  };

  cb.prototype.targetRef = callback;
  return register(eventName, cb, uniqueId);
};

const deRegister = function (eventName, callback) {
  let uniqueId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : GLOBAL;

  if (!isQueued(eventName, uniqueId)) {
    return false;
  }

  if (isFunction(callback)) {
    const len = queue[eventName][uniqueId].length;

    for (let i = len - 1; i >= 0; i--) {
      const fn = queue[eventName][uniqueId][i];

      if (callback === fn || fn.prototype && callback === fn.prototype.targetRef) {
        queue[eventName][uniqueId].splice(i, 1);
      }
    }
  } else {
    queue[eventName][uniqueId] = [];
  }

  if (queue[eventName][uniqueId].length === 0) {
    delete queue[eventName][uniqueId];

    if (objEmpty(queue[eventName])) {
      delete queue[eventName];
    }
  }

  return true;
};

const trigger = function (eventName, data) {
  let uniqueId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : GLOBAL;
  let globalPropagation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  const _propagate = globalPropagation && uniqueId !== GLOBAL;

  if (!isQueued(eventName, uniqueId)) {
    if (_propagate) {
      trigger(eventName, data);
    }

    return false;
  }

  const len = queue[eventName][uniqueId].length;

  if (!len) {
    if (_propagate) {
      trigger(eventName, data);
    }

    return false;
  }

  for (let i = len - 1; i >= 0; i--) {
    queue[eventName][uniqueId][i](data);
  }

  if (_propagate) {
    trigger(eventName, data);
  }

  return true;
};

const deRegisterAll = eventName => {
  delete queue[eventName];
};

export { trigger, register, registerOnce, deRegister, deRegisterAll, isQueued, queueLength };